import React from 'react'
import { action, observable } from 'mobx'
import { MenuItem, DropdownButton } from 'react-bootstrap'

import Ds from './ds'

class PartnerTypes {
  @observable data = []
  @observable partnerCompanies = []
  @observable ds = new Ds()

  @action findPartnerCompanyByName(name) {
    let id = 0;
    for(let i=0; i<this.partnerCompanies.length; i++) {
      if (this.partnerCompanies[i].name == name) {
        return this.partnerCompanies[i].id
      }
    }

    return id
  }

  @action loadAllPartnerTypes() {
    this.ds.query(`{ partnerTypes(hash: "${ localStorage.getItem('userHash') }") { id name partnerCompanyId partnerCompany { id name } } }`, (data) => {
      this.data = data.partnerTypes.map((d) => {
        d.partnerCompanyName = d.partnerCompany.name
        return d
      })
    })
  }

  @action loadAllPartnerCompanies() {
    this.ds.query(`{
      partnerCompanies(
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        name
        partnerTypes {
          id
          name
        }
      }
    }`,  (data) => {
      this.partnerCompanies = data.partnerCompanies
    })
  }

  @action newPartnerType(row) {
    const partnerCompanyId = this.findPartnerCompanyByName(row.partnerCompanyName)

    this.ds.query(`mutation { addPartnerType(name: "${ row.name }", partnerCompanyId: ${ partnerCompanyId }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllPartnerTypes()
    })
  }

  @action updatePartnerType(id, row) {
    const partnerCompanyId = this.findPartnerCompanyByName(row.partnerCompanyName)

    this.ds.query(`mutation { updatePartnerType(id: ${ id }, name: "${ row.name }", partnerCompanyId: ${ partnerCompanyId }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllPartnerTypes()
    })
  }

  @action deletePartnerType(id) {
    this.ds.query(`mutation { deletePartnerType(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllPartnerTypes()
    })
  }
}

export default new PartnerTypes



// WEBPACK FOOTER //
// ./src/stores/partnertypes.js